import React from 'react';
import PropTypes from 'prop-types';
import QualifiedPlayerCardItem from '../../qualified-player-card/js/QualifiedPlayerCardItem';

export default function QualifiedGolfersPlayersList({ items }) {
    return (
        <ul className="qualified-golfers-players-list">
            {items.map((item, i) => (
                <li className="qualified-golfers-players-list__item" key={item.id}>
                    <QualifiedPlayerCardItem index={i} item={item}/>
                </li>
            ))}
        </ul>
    );
}

QualifiedGolfersPlayersList.propTypes = {
    items: PropTypes.array.isRequired,
};
